import { memo, useCallback } from 'react';

import { SortDirection } from '@air/api/types';
import { SegmentedControl, type SegmentedControlOption } from '@air/component-segmented-control';

export type SortMenuDirectionControlProps = {
  direction: SortDirection;
  onChange: (direction: SortDirection) => void;
};

const DIRECTION_OPTIONS: Record<SortDirection, SegmentedControlOption> = {
  [SortDirection.asc]: {
    id: SortDirection.asc,
    label: 'Ascending',
    testId: 'SORT_MENU_DIRECTION_ASC',
    tooltip: 'Ascending',
    value: SortDirection.asc,
  },
  [SortDirection.desc]: {
    id: SortDirection.desc,
    label: 'Descending',
    testId: 'SORT_MENU_DIRECTION_DESC',
    tooltip: 'Descending',
    value: SortDirection.desc,
  },
};

const DIRECTION_OPTION_LIST = [DIRECTION_OPTIONS[SortDirection.asc], DIRECTION_OPTIONS[SortDirection.desc]];

export const SortMenuDirectionControl = memo(({ direction, onChange }: SortMenuDirectionControlProps) => {
  const selectedOption = DIRECTION_OPTIONS[direction];

  const handleSelect = useCallback(
    (option: SegmentedControlOption) => {
      onChange(option.value === SortDirection.asc ? SortDirection.asc : SortDirection.desc);
    },
    [onChange],
  );

  return (
    <div className="flex flex-col gap-1.5 px-1.5" data-testid="SORT_MENU_DIRECTION">
      <span className="font-medium ads:text-primary text-14 text-gray-12">Direction</span>
      <SegmentedControl
        appearance="rectangle"
        color="gray"
        fullWidth
        onSelect={handleSelect}
        options={DIRECTION_OPTION_LIST}
        outerAppearance="default"
        selectedOption={selectedOption}
        size="xsmall"
      />
    </div>
  );
});

SortMenuDirectionControl.displayName = 'SortMenuDirectionControl';
